export default {
  cancelButton: 'Cancel',
  dateRangeLabel: 'Time range *',
  periods: {
    today: 'Today',
    yesterday: 'Yesterday',
    last24hours: 'Last 24 hours',
    currentWeek: 'Current week',
    currentMonth: 'Current month',
    lastMonth: 'Last month',
    last7days: 'Last 7 days',
    last30days: 'Last 30 days',
  },
  previousPeriods: {
    today: 'yesterday',
    yesterday: 'the day before yesterday',
    last24hours: 'in the previous 24 hours',
    currentWeek: 'last week',
    currentMonth: 'last month',
    lastMonth: 'the month before last',
    last7days: 'in the previous 7 days',
    last30days: 'in the previous 30 days',
    custom: 'in the same previous interval',
  },
};
